// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__39_NS","body":"Modal_body__1olmh"};